/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GetCheckUnTranslatedResponseAdmin } from '../models/GetCheckUnTranslatedResponseAdmin';
import type { GetTranslationsResponseAdmin } from '../models/GetTranslationsResponseAdmin';
import type { PutTranslationTextRequestAdmin } from '../models/PutTranslationTextRequestAdmin';
import type { TextTranslationAdminDto } from '../models/TextTranslationAdminDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TranslationService {
    /**
     * **Required Policy:** `ViewTranslations`
     * @returns GetCheckUnTranslatedResponseAdmin OK
     * @throws ApiError
     */
    public static getCheckUnTranslatedAdmin(): CancelablePromise<GetCheckUnTranslatedResponseAdmin> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/translation/check-untranslated',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewTranslations`
     * @returns GetTranslationsResponseAdmin OK
     * @throws ApiError
     */
    public static getTranslationsAdmin(): CancelablePromise<GetTranslationsResponseAdmin> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/translation',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageTranslations`
     * @returns TextTranslationAdminDto OK
     * @throws ApiError
     */
    public static putTranslationAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutTranslationTextRequestAdmin,
    }): CancelablePromise<TextTranslationAdminDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/translation/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
